import { render, staticRenderFns } from "./HoldConversions.vue?vue&type=template&id=6dd53d92&scoped=true&"
import script from "./HoldConversions.vue?vue&type=script&setup=true&lang=ts&"
export * from "./HoldConversions.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./HoldConversions.vue?vue&type=style&index=0&id=6dd53d92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd53d92",
  null
  
)

export default component.exports